import script from "./ReaderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReaderPage.vue?vue&type=script&setup=true&lang=js"

import "./ReaderPage.vue?vue&type=style&index=0&id=53461123&scoped=true&lang=css"
import "../styles/modal.css?vue&type=style&index=1&lang=css&external"
import "../styles/resize_pane.css?vue&type=style&index=2&lang=css&external"
import "./ReaderPage.vue?vue&type=style&index=3&id=53461123&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53461123"]])

export default __exports__